export default __webpack_public_path__ + "static/media/video_web_thumb.f2e38884.png";